module.exports = __webpack_public_path__ + "img/2nd-child-2-min.b06eb7a8.jpg";